import { useAuth } from 'react-oidc-context';
import { useCallback } from 'react';

// Hook version - use this in React components
export function useAuthFetch() {
  const auth = useAuth();

  return useCallback(
    async (input: RequestInfo, init: RequestInit = {}) => {
      const token = auth.user?.access_token;

      console.log('AuthFetch - Token available:', !!token);
      console.log(
        'AuthFetch - Token preview:',
        token?.substring(0, 50) + '...'
      );

      const headers = {
        ...(init.headers || {}),
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      };

      console.log('AuthFetch - Headers:', headers);

      return fetch(input, { ...init, headers });
    },
    [auth.user?.access_token]
  );
}

// Utility function version - pass token explicitly
export async function authFetch(
  input: RequestInfo,
  init: RequestInit = {},
  token?: string
) {
  const headers = {
    ...(init.headers || {}),
    ...(token && { Authorization: `Bearer ${token}` }),
    'Content-Type': 'application/json',
  };

  return fetch(input, { ...init, headers });
}
